import React, { useEffect, useState } from "react";
import IconInput from "../../../../styled-components/input/icon-input";
import DropDown from "../../../../styled-components/dropdown/dropdown";
import * as B from "../../../../styled-components/button";
import { Text } from "../../../../styled-components/text";
import AddModal from "../../../../styled-components/modal/add-modal/add-modal";
import UpdateModal from "../../../../styled-components/modal/update-modal/update-modal";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import * as Style from "./styles/tax-credits";
import { Button, DatePicker } from "antd";
import TaxInformation from "../tax-information/tax-information";
import CapitalGains from "../capital-gains/capital-gains";
import { PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import InputTax from "../../../../styled-components/input/input-tax";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import swal from "sweetalert";
import Loader from "../../../../styled-components/loader/loader";
import Styles from "../../../../../constants/style-constants/styles";
import moment from "moment";
import DateInput from "../../../../styled-components/input/styles/date-input-new";
import AddCreditNewModal from "../../../../styled-components/modal/add-modal/add-credit-new-modal";
import UpdateCreditModalNew from "../../../../styled-components/modal/update-modal/update-credit-modal-new";
import {
  TaxSkeletonBox,
  TaxInflationButtonContent,
  TaxInflationInlineLoader,
} from "../tax-inflation-loading";

const UnknownDollarValueCheckbox = (props) => {
  const { value = false, onChange, name = "unknownDollarValue" } = props.value;
  const { styles } = defaultStyles;
  const handleCheckboxChange = (e) => {
    onChange({ name, value: e.target.checked });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "14rem",
      }}
    >
      <Text style={styles.text.labelText}> Dollar Value Unknown</Text>
      <input
        type="checkbox"
        checked={value}
        name={name}
        onChange={onChange}
        style={{ width: "16px", height: "16px", cursor: "pointer" }}
      />
    </div>
  );
};

function TaxCredits({
  handleTaxInflationObject,
  nextForm,
  preForm,
  parentLoading,
}) {
  const taxCreditObj = {
    taxCredit: "",
    amountOfCredit: "",
    appliesTo: "",
    unknownDollarValue: false,
    date: "",
    description: "",
  };

  const [taxCreditData, setTaxCreditData] = useState({ ...taxCreditObj });
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();
  const [updatedObject, setUpdateObject] = useState({});
  const isBusy = loading || parentLoading;
  const showSkeleton = isBusy && dataList.length === 0;

  const { styles } = defaultStyles;

  const professionList = [
    { id: 1, name: "Bookkeeper" },
    { id: 2, name: "CPA" },
    { id: 3, name: "Financial Advisor" },
  ];

  const taxCreditList = [
    { id: 1, name: "Child Tax Credit" },
    { id: 2, name: "Child & Dependent Care Credit" },
    { id: 3, name: "Adoption Credit" },
    { id: 4, name: "Earned Income Tax Credit (EITC)" },
    { id: 5, name: "American Opportunity Credit" },
    { id: 6, name: "Lifetime Learning Credit" },
    { id: 7, name: "Saver's Credit" },
    { id: 8, name: "Premium Tax Credit" },
    { id: 9, name: "Clean Vehicle Credit" },
    { id: 10, name: "Energy Efficient Home Improvement Credit" },
    { id: 11, name: "Residential Clean Energy Credit" },
    { id: 12, name: "Foreign Tax Credit" },
    { id: 22, name: "Other" },
  ];

  const handleTaxCreditInfo = (obj) => {
    if (obj && obj._isAMomentObject) {
      // const isoString = moment(obj._d).toISOString();
      setTaxCreditData({
        ...taxCreditData,
        date: obj._d,
      });
    } else {
      // const { name, value } = obj;
      const name = obj && obj.name;
      const value =
        obj && obj.name && obj.name === "unknownDollarValue"
          ? obj.checked
          : obj.value;
      setTaxCreditData({
        ...taxCreditData,
        [name]: value,
      });
    }
  };

  const handleTaxCreditUpdatedInfo = (obj) => {
    const { name, value } = obj;
    if (obj && obj._isAMomentObject) {
      setUpdateObject({
        ...updatedObject,
        date: obj._d,
      });
    } else {
      const name = obj && obj.name;
      const value =
        obj && obj.name && obj.name === "unknownDollarValue"
          ? obj.checked
          : obj.value;
      setUpdateObject({
        ...updatedObject,
        [name]: value,
      });
    }
  };

  const nextComponent = {
    name: "capitalGains",
    title: "Capital Gains",
    unique: "firstName",
    component: CapitalGains,
    isMulti: true,
    capitalGains: {},
  };

  const preComponent = {
    name: "taxInformation",
    title: "Tax Information",
    unique: "firstName",
    isMulti: false,
    component: TaxInformation,
    taxInformation: {},
  };
  const getTaxCredit = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxCreditList();
      if (data && data.data) {
        setDataList(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  useEffect(() => {
    getTaxCredit();
  }, []);
  const submitData = async () => {
    if (
      taxCreditData["taxCredit"] !== "" ||
      taxCreditData["amountOfCredit"] !== "" ||
      taxCreditData["appliesTo"] !== ""
    ) {
      let payload = taxCreditData["unknownDollarValue"]
        ? {
            taxCredit: taxCreditData["taxCredit"],
            appliesTo: taxCreditData["appliesTo"],
            unknownDollarValue: taxCreditData["unknownDollarValue"],
            date:
              taxCreditData["date"] &&
              moment(taxCreditData["date"]).toISOString(),
            description: taxCreditData["description"],
          }
        : {
            taxCredit: taxCreditData["taxCredit"],
            amountOfCredit: +taxCreditData["amountOfCredit"],
            appliesTo: taxCreditData["appliesTo"],
            unknownDollarValue: taxCreditData["unknownDollarValue"],
            date:
              taxCreditData["date"] &&
              moment(taxCreditData["date"]).toISOString(),
            description: taxCreditData["description"],
          };
      try {
        setLoading(true);
        let res = await TAX_AND_INFLATION_API.saveTaxCredit(payload);
        if (res && res.status === 200) {
          await getTaxCredit();
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error while creating tax credit", error);
      }
      setTaxCreditData(taxCreditObj);
    }
  };

  const getSelectedRow = (idx) => {
    setShowUpdateModal(true);

    setSelectedIndex(idx);

    // get selected row (this will return array of object)
    const selectedRow = dataList.filter((row, index) => {
      return index == idx;
    });

    console.log("selected row", selectedRow);

    const updated = { ...selectedRow[0] };
    if (updated.date && typeof updated.date === "string") {
      updated.date = new Date(updated.date);
    }

    setUpdateObject(updated);
    // setUpdateObject(selectedRow[0]);
  };

  const updateRow = async () => {
    let payload =
      updatedObject["unknownDollarValue"] === true
        ? {
            id: updatedObject["id"],
            amountOfCredit: null,
            taxCredit: updatedObject["taxCredit"],
            appliesTo: updatedObject["appliesTo"],
            date: updatedObject["date"],
            description: updatedObject["description"],
            unknownDollarValue: updatedObject["unknownDollarValue"],
          }
        : {
            id: updatedObject["id"],
            taxCredit: updatedObject["taxCredit"],
            amountOfCredit: +updatedObject["amountOfCredit"],
            appliesTo: updatedObject["appliesTo"],
            date: updatedObject["date"],
            description: updatedObject["description"],
            unknownDollarValue: updatedObject["unknownDollarValue"],
          };
    try {
      setLoading(true);
      let res = await TAX_AND_INFLATION_API.updateTaxCredit(payload);
      if (res && res.status === 200) {
        await getTaxCredit();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while updating tax credit", error);
    }
    setTaxCreditData(taxCreditObj);
    // handleTaxInflationObject(dataList);
  };

  const deleteRow = (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        let payload = {
          id: id,
        };
        try {
          setLoading(true);
          let res = await TAX_AND_INFLATION_API.deleteTaxCredit(id);
          if (res && res.status === 200) {
            swal("Deleted!", "Your tax credit has been deleted.", "success");
            await getTaxCredit();
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while updating tax credit", error);
        }
      }
    });
  };

  const handelCloseModal = () => {
    setShowModal(false);
    setShowUpdateModal(false);
  };

  const fields = [
    {
      Component: DropDown,
      value: {
        style: styles.dropDown.smallDropDownNew,
        name: "taxCredit",
        // title: "Other Tax Credit",
        title: "Tax Credit Type",
        setSelectedItem: handleTaxCreditInfo,
        list: taxCreditList,
        displayKey: "name",
        tooltip: "tax_credit_type",
      },
    },
    // {
    //   Component: UnknownDollarValueCheckbox,
    //   value: {
    //     name: "unknownDollarValue",
    //     value: !!taxCreditData["unknownDollarValue"],
    //     onChange:  (event) => handleTaxCreditInfo(event.target),
    //   },
    // },
    // {
    //   Component: IconInputTax,
    //   value: {
    //     name: "amountOfCredit",
    //     title: "Amount Of Credit",
    //     icon: "$",
    //     iconPosition: "start",
    //     value: taxCreditData["amountOfCredit"],
    //     onChange: (event) => handleTaxCreditInfo(event.target),
    //   },
    // },
    {
      Component: InputTax,
      value: {
        style: styles.textInput.smallTextInput,
        name: "appliesTo",
        title: "Whose Credit",
        onChange: (event) => handleTaxCreditInfo(event.target),
        displayKey: "name",
        tooltip:"whose_credit"
      },
    },
    {
      Component: DateInput,
      value: {
        name: "date",
        title: "Date",
        value: taxCreditData["date"], // should be in string format
        onChange: (event) => {
          handleTaxCreditInfo(event);
        },
        tooltip: "date",
      },
    },
    {
      Component: InputTax,
      value: {
        style: styles.textInput.smallTextInput,
        name: "description",
        title: "Description",
        onChange: (event) => {
          handleTaxCreditInfo(event.target);
        },
        value: taxCreditData["description"],
        displayKey: "name",
        tooltip: "description",
      },
    },
  ];

  const update_fields = [
    {
      Component: DropDown,
      value: {
        style: styles.dropDown.smallDropDownNew,
        name: "taxCredit",
        title: "Tax Credit Type",
        setSelectedItem: handleTaxCreditUpdatedInfo,
        list: taxCreditList,
        displayKey: "name",
        value: updatedObject["taxCredit"],
        tooltip: "tax_credit_type",
      },
    },
    // {
    //   Component: IconInputTax,
    //   value: {
    //     style: styles.textInput.smallTextInput,
    //     name: "amountOfCredit",
    //     title: "Amount Of Credit",
    //     icon: "$",
    //     iconPosition: "start",
    //     value: updatedObject["amountOfCredit"],
    //     onChange: (event) => handleTaxCreditUpdatedInfo(event.target),
    //   },
    // },
    {
      Component: InputTax,
      value: {
        style: styles.textInput.smallTextInput,
        name: "appliesTo",
        title: "Whose Credit",
        onChange: (event) => handleTaxCreditUpdatedInfo(event.target),
        value: updatedObject["appliesTo"],
        displayKey: "name",
        tooltip: "whose_credit",
      },
    },
    {
      Component: DateInput,
      value: {
        name: "date",
        title: "Date",
        value: updatedObject["date"], // should be in string format
        onChange: (event) => {
          handleTaxCreditUpdatedInfo(event);
        },
        tooltip: "date",
      },
      
    },
    {
      Component: InputTax,
      value: {
        style: styles.textInput.smallTextInput,
        name: "description",
        title: "Description",
        onChange: (event) => {
          handleTaxCreditUpdatedInfo(event.target);
        },
        value: updatedObject["description"],
        displayKey: "name",
        tooltip: "description",
      },
    },
  ];

  if (showSkeleton) {
    return (
      <div style={{ position: "relative" }}>
        <Style.MainContainer>
          <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
            New Tax Credit
          </h3>
          <Style.FieldsContainer style={{ marginTop: 16 }}>
            <TaxSkeletonBox width={160} height={22} />
            <TaxSkeletonBox width={38} height={38} radius={10} />
          </Style.FieldsContainer>
          {[1, 2, 3].map((k) => (
            <Style.RowContainer key={k}>
              <Style.LeftContainer>
                <TaxSkeletonBox width={14} height={14} radius={4} />
              </Style.LeftContainer>
              <Style.RightContainer>
                <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
                  <TaxSkeletonBox width="30%" />
                  <TaxSkeletonBox width="30%" />
                  <TaxSkeletonBox width="30%" />
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <TaxSkeletonBox width={24} height={24} radius={6} />
                  <TaxSkeletonBox width={24} height={24} radius={6} />
                </div>
              </Style.RightContainer>
            </Style.RowContainer>
          ))}
          <Style.ButtonsContainer>
            <TaxSkeletonBox width={120} height={38} radius={999} />
            <TaxSkeletonBox width={120} height={38} radius={999} />
          </Style.ButtonsContainer>
        </Style.MainContainer>
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <Style.MainContainer>
        <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
          New Tax Credit
        </h3>

        <Style.FieldsContainer>
          <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "24px" }}>
            Tax Credit
          </h3>
          <B.Button
            style={styles.button.sqaureButton}
            onClick={() => setShowModal(true)}
          >
            <PlusOutlined style={{ color: "#ffffff" }} />
          </B.Button>
        </Style.FieldsContainer>

        {dataList &&
          dataList.map((item, index) => (
            <Style.RowContainer key={index}>
              <Style.LeftContainer>{index + 1}</Style.LeftContainer>
              <Style.RightContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    width: "100%",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Text style={{ textWrap: "nowrap" }}>
                    <span style={{ fontWeight: "bold" }}>Other Tax Credit</span>{" "}
                    :{item["taxCredit"] ? item["taxCredit"] : ""}
                  </Text>
                  <Text style={{ textWrap: "nowrap" }}>
                    <span style={{ fontWeight: "bold" }}>Amount of Credit</span>{" "}
                    :
                    {item["amountOfCredit"]
                      ? "$" + item["amountOfCredit"]
                      : "$0.0"}
                  </Text>
                  <Text style={{ textWrap: "nowrap" }}>
                    <span style={{ fontWeight: "bold" }}>Whose Credit</span> :
                    {item["appliesTo"] ? item["appliesTo"] : ""}
                  </Text>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // gap: "1rem",
                  }}
                >
                  <Button
                    type="link"
                    style={{ fontSize: "21px" }}
                    icon="edit"
                    onClick={() => getSelectedRow(index)}
                  ></Button>

                  <Button
                    type="link"
                    style={{ fontSize: "21px" }}
                    icon="delete"
                    onClick={() => deleteRow(item.id)}
                  ></Button>
                </div>
              </Style.RightContainer>
            </Style.RowContainer>
          ))}

        <Style.ButtonsContainer>
          <button
            className="tax-inflation-prev-button"
            disabled={isBusy}
            onClick={() => preForm(preComponent)}
          >
            Previous
          </button>
          <button
            className="tax-inflation-next-button"
            disabled={isBusy}
            onClick={() => nextForm(nextComponent)}
          >
            <TaxInflationButtonContent
              isLoading={isBusy}
              idleText="Next"
              loadingText="Loading..."
            />
          </button>
        </Style.ButtonsContainer>
      </Style.MainContainer>
      {/* <AddModal
        show={showModal}
        close={handelCloseModal}
        fields={fields}
        modalTitle={"Add Tax Credit"}
        handleTaxCreditInfo={handleTaxCreditInfo}
        setTaxCreditData={setTaxCreditData}
        submitData={submitData}
      /> */}
      <AddCreditNewModal
        show={showModal}
        close={handelCloseModal}
        fields={fields}
        modalTitle={"Add Tax Credit"}
        handleTaxCreditInfo={handleTaxCreditInfo}
        setTaxCreditData={setTaxCreditData}
        submitData={submitData}
        taxCreditData={taxCreditData}
      />
      {/* <UpdateModal
        show={showUpdateModal}
        close={handelCloseModal}
        fields={update_fields}
        setTaxCreditData={setTaxCreditData}
        updateRow={updateRow}
      /> */}
      <UpdateCreditModalNew
        show={showUpdateModal}
        close={handelCloseModal}
        fields={update_fields}
        setTaxCreditData={setTaxCreditData}
        updateRow={updateRow}
        updatedObject={updatedObject}
        handleTaxCreditUpdatedInfo={handleTaxCreditUpdatedInfo}
      />
      <div style={{ marginTop: "10px" }}>
        <TaxInflationInlineLoader
          isLoading={isBusy}
          text="Loading tax credits..."
        />
      </div>
    </div>
  );
}

export default TaxCredits;
